define('components/photoset/layouts/fitColumn/column', [], function () {
    function Model(jsonModel) {
        this.items = ko.observableArray([]);
        this.isEmpty = this.items.isEmpty();
        this.offset = ko.observable(jsonModel.offset).unwrap();

        this.relHeight = this.items.reduce(function (value, item) { return value + item.relHeight() }, () => 0);        
        this.relWidth = this.relHeight.mapSingle(function (value) { return value > 0 ? 1 / value : 0 });

        this.width = ko.observable(null);
        this.height = this.width.mapNotNull(function (width) {
            return width.multiply(this.relHeight()).add(0, this.offset() * (this.items().length - 1));
        }, this);
    }

    Model.prototype.add = function (item) {
        this.items.push(item);
    };

    Model.prototype.remove = function (item) {
        this.items.remove(item);
    };

    Model.prototype.removeAll = function (items) {
        this.items.removeAll(items);
    };

    Model.prototype.clear = function () {
        this.items([]);
    };

    return Model;
});